import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UnitService } from "./unit.service";

const initialState = {
  units: [],
  unit: null,
  success: false,
  isLoading: false,
  error: null,
  message: null,
};

export const addUnit = createAsyncThunk(
  "unit/addUnit",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _unitService = new UnitService();
      const response = await _unitService.addUnit(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUnits = createAsyncThunk(
  "unit/getUnits",
  async (_, { rejectWithValue, getState }) => {
    try {
      const _unitService = new UnitService();
      const response = await _unitService.getUnits();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUnit = createAsyncThunk(
  "unit/getUnit",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _unitService = new UnitService();
      const response = await _unitService.getUnit(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateUnit = createAsyncThunk(
  "unit/updateUnit",
  async (data, { rejectWithValue }) => {
    try {
      const _unitService = new UnitService();
      const response = await _unitService.updateUnit(data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update unit"
      );
    }
  }
);

export const deleteUnit = createAsyncThunk(
  "unit/deleteUnit",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _unitService = new UnitService();
      const response = await _unitService.deleteUnit(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const unitSlice = createSlice({
  name: "unit",
  initialState,
  reducers: {
    reset: (state) => {
      state.success = false;
      state.isLoading = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUnit.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.unit = action.payload?.data;
        state.success = true;
        state.message = action.payload?.message || "Unit added successfully";
      })
      .addCase(addUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add unit";
      })

      .addCase(getUnits.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnits.fulfilled, (state, action) => {
        state.isLoading = false;
        const payload = action.payload?.data;
        state.units = Array.isArray(payload) ? payload : [];
      })
      .addCase(getUnits.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to load units";
      })

      .addCase(getUnit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.unit = action.payload;
      })
      .addCase(getUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateUnit.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.unit = action.payload?.data;
        state.success = true;
        state.message = action.payload?.message || "Unit updated successfully";
      })
      .addCase(updateUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to update unit";
      })

      .addCase(deleteUnit.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload?.message || "Unit deleted successfully";
      })
      .addCase(deleteUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to delete unit";
      });
  },
});

export const { reset } = unitSlice.actions;
export default unitSlice.reducer;
